
import { getAll } from "../utilities/querySelector";
import { splitCharacters } from "../utilities/splitCharacters";

const headings = getAll("[data-handwriting]");
headings.forEach((heading) => {
    if (heading.hasAttribute(["data-aos"])) {
        splitCharacters(heading);
    }
});